function isNumber(maybeNumber) {
  return !isNaN(maybeNumber) && maybeNumber !== null;
}

export default isNumber;
